<template>
  <div class="rm-page">
    <sub-navigation :items="menuItems"/>
    <div class="rm-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import SubNavigation from '@/components/SubNavigation'

export default {
  name: 'RunnerManager',
  data: () => ({
    menuItems: [
      { to: '/admin/runners/allrunners', title: 'All Runners' },
      { to: '/admin/runners/with-run-completed', title: 'Days Since Last LiveRun' },
      { to: '/admin/runners/all-lucky-liverunners', title: 'Lucky LiveRunner' }
    ]
  }),
   
  created() {
    if (!this.$isAdminUser()) {
      this.$router.push({ path: '/403' })
    }
  },
  components: {
    SubNavigation
  }
}
</script>

<style scoped>
.rm-page {
  background: #fff;
}

.rm-content {
  width: 100%;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 1.25rem;
  padding-bottom: 5.5rem;
}

@media (max-width: 900px) {
  .rm-content {
    padding-left: 24px;
    padding-right: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// RunnerManager.vue?052db1aa